import React from "react";
import { Link, useLocation } from "react-router-dom";
import HorizontalRuleIcon from "@mui/icons-material/HorizontalRule";

const Breadcrumb = () => {
  const location = useLocation();

  return (
    <>
      <div className="d-flex bread-crumb align-items-center ">
        <Link
          style={{ textDecoration: "none", color: "#fff" }}
          to="/training/my-requests"
          className={`  px-1 rounded  ${
            location.pathname.includes("/training/my-requests") ? "active" : " "
          }`}
        >
          <span className="text-truncate  menu-item">My Requests</span>
        </Link>
      </div>
    </>
  );
};

export default Breadcrumb;
